import { createFileRoute } from "@tanstack/react-router";
import { OrgPermissionsContainer } from "@/features/organisation/containers/org-permissions-container";

export const Route = createFileRoute("/app/settings/organisation/permissions")({
  component: OrgPermissionsContainer,
});
